import { restManager } from '@/plugin/restManager.js';

const alarmStore = {
  namespaced: true,
  state: () => ({}),
  getters: {},
  mutations: {},
  actions: {
    createAlarmGroup({ commit }, payload) {
      return new Promise((resolve, reject) => {
        restManager.system
          .post('/v1/console/address-books', payload, false, true)
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    updateAlarmGroup({ commit }, payload) {
      return new Promise((resolve, reject) => {
        restManager.system
          .put(`/v1/console/address-books/${payload.addressBookSq}`, payload.body, false, true)
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    getAlarmGroupDetail({ commit }, { addressBookSq }) {
      return new Promise((resolve, reject) => {
        restManager.system
          .get(`/v1/console/address-books/${addressBookSq}`)
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    deleteAlarmGroup({ commit }, payload) {
      return new Promise((resolve, reject) => {
        restManager.system
          .delete('/v1/console/address-books', {}, payload)
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    }
  }
};

export default alarmStore;
